export enum REPORT {
    // Dashboard Reports
    DASHBOARD_TIPS = 'DASHBOARD_TIPS',
    TOTAL_SUCCESSFUL_CUTS_BY_MONTH = 'TOTAL_SUCCESSFUL_CUTS_BY_MONTH',
    TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_THIS_MONTH = 'TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_THIS_MONTH',
    TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH = 'TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH',
    WARRANTY_RATE_BY_MONTH_COMPARED_TO_GLOBAL_AVERAGE = 'WARRANTY_RATE_BY_MONTH_COMPARED_TO_GLOBAL_AVERAGE',
    MANUFACTURER_BREAKDOWN = 'MANUFACTURER_BREAKDOWN',
    MO_GLOBAL_PRESENCE = 'MO_GLOBAL_PRESENCE',
    AVERAGE_CUTS_PER_LOCATION_PER_COUNTRY_PER_MONTH_COMPARED_TO_REGION_AVERAGE = 'AVERAGE_CUTS_PER_LOCATION_PER_COUNTRY_PER_MONTH_COMPARED_TO_REGION_AVEGARE',
    CUT_BY_CATEGORY_LOCATION = 'CUT_BY_CATEGORY_LOCATION',
    CUT_BY_CATEGORY = 'CUT_BY_CATEGORY',

    // Reseller Reports
    RESELLER_TIPS = 'RESELLER_TIPS',
    RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_LAST_MONTH = 'RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_LAST_MONTH',
    RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_THIS_MONTH = 'RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_THIS_MONTH',
    RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_FOR_DATE_RANGE = 'RESELLER_SUCCESSFUL_CUTS_BY_RESELLER_FOR_DATE_RANGE',
    RESELLER_AVERAGE_CUTS_PER_LOCATION_PER_RESELLER = 'RESELLER_AVERAGE_CUTS_PER_LOCATION_PER_RESELLER',
    RESELLER_FULL_BODY_PERCENTAGE_RATE_PER_RESELLER = 'RESELLER_FULL_BODY_PERCENTAGE_RATE_PER_RESELLER',
    RESELLER_WARRANTY_RATE_BY_RESELLER_COMPARED_TO_GLOBAL_AVERAGE = 'RESELLER_WARRANTY_RATE_BY_RESELLER_COMPARED_TO_GLOBAL_AVERAGE',
    RESELLER_CUT_VOLUME_GROWTH_BY_RESELLER = 'RESELLER_CUT_VOLUME_GROWTH_BY_RESELLER',
    RESELLER_MATERIAL_TYPE_CUTS_BY_RESELLER = 'RESELLER_MATERIAL_TYPE_CUTS_BY_RESELLER',
    RESELLER_MATERIAL_TYPE_PERFORMANCE_AS_A_PERCENTAGE_BY_RESELLER = 'RESELLER_MATERIAL_TYPE_PERFORMANCE_AS_A_PERCENTAGE_BY_RESELLER',
    RESELLER_NUMBER_OF_ACTIVE_LOCATIONS_BY_RESELLER = 'RESELLER_NUMBER_OF_ACTIVE_LOCATIONS_BY_RESELLER',

    // Location
    LOCATION_TIPS = 'LOCATION_TIPS',
    LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_THIS_MONTH = 'LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_THIS_MONTH',
    LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH = 'LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_LAST_MONTH',
    LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_FOR_DATE_RANGE = 'LOCATION_TOTAL_SUCCESSFUL_CUTS_BY_LOCATION_FOR_DATE_RANGE',
    LOCATION_FULL_BODY_RATE_PER_LOCATION = 'LOCATION_FULL_BODY_RATE_PER_LOCATION',
    LOCATION_WARRANTY_RATE_BY_LOCATION = 'LOCATION_WARRANTY_RATE_BY_LOCATION',
    LOCATION_MONTHLY_CUT_VOLUME_GROWTH_BY_LOCATION = 'LOCATION_MONTHLY_CUT_VOLUME_GROWTH_BY_LOCATION',
    LOCATION_MATERIAL_TYPE_CUTS_BY_LOCATION = 'LOCATION_MATERIAL_TYPE_CUTS_BY_LOCATION',
    LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_COUNTRY = 'LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_COUNTRY',
    LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_LOCATION = 'LOCATION_PERCENTAGE_PRODUCT_REGISTRATIONS_PER_LOCATION',

    // Products
    PRODUCTS_TIPS = 'PRODUCTS_TIPS',
    PRODUCTS_OVERALL_FULL_BODY_RATE = 'PRODUCTS_OVERALL_FULL_BODY_RATE',
    PRODUCTS_OVERALL_TOTAL_WARRANTY_RATE_BY_MONTH_BY_MATERIAL = 'PRODUCTS_OVERALL_TOTAL_WARRANTY_RATE_BY_MONTH_BY_MATERIAL',
    PRODUCTS_OVERALL_MATERIAL_TYPE_CUT_PERCENTAGE = 'PRODUCTS_OVERALL_MATERIAL_TYPE_CUT_PERCENTAGE',
    PRODUCTS_OVERALL_MATERIAL_TYPE_CUT_PERCENTAGE_OVER_TIME = 'PRODUCTS_OVERALL_MATERIAL_TYPE_CUT_PERCENTAGE_OVER_TIME',
    PRODUCTS_SUCCESSFUL_CUTS_BY_COVERAGE_TYPE = 'PRODUCTS_SUCCESSFUL_CUTS_BY_COVERAGE_TYPE',
    PRODUCTS_SUCCESSFUL_CUT_VOLUME_BY_MODEL = 'PRODUCTS_SUCCESSFUL_CUT_VOLUME_BY_MODEL',
    PRODUCTS_LOCATION_GLOBAL_RANK_OF_MATERIAL = 'PRODUCTS_LOCATION_GLOBAL_RANK_OF_MATERIAL',
    PRODUCTS_PRODUCT_NAMES = 'PRODUCTS_PRODUCT_NAMES',

    // ISSUES
    ISSUES_TIPS = 'ISSUES_TIPS',
    ISSUES_LOCATIONS_CUT_LAST_MONTH = 'ISSUES_LOCATIONS_CUT_LAST_MONTH',
    ISSUES_RESELLERS_CUT_LAST_MONTH = 'ISSUES_RESELLERS_CUT_LAST_MONTH',
    ISSUES_LOCATIONS_HAVE_NOT_CUT_IN_PAST_SEVEN_DAYS = 'ISSUES_LOCATIONS_HAVE_NOT_CUT_IN_PAST_SEVEN_DAYS',
    ISSUES_LOCATIONS_WITH_OVER_FIFTY_PERCENTAGE_WARRANTY_RATE = 'ISSUES_LOCATIONS_WITH_OVER_FIFTY_PERCENTAGE_WARRANTY_RATE',
    ISSUES_LOCATIONS_HAVE_NOT_CUT = 'ISSUES_LOCATIONS_HAVE_NOT_CUT',
}

export enum REPORT_RANGE {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    YEARLY = 'yearly',
}

export enum ReportToggleTypes {
    ToggleTableType = 'ToggleTableType',
    ToggleChartType = 'ToggleChartType',
}
